import { WizLabel } from './../components/controls/wiz-label/wiz-label';
import { WizComponentManager } from './../services/core/component/wiz-component.manager';
import { ViewContainerRef } from '@angular/core';
import { WizValidationErrors, WizValidationError } from './../services/validators/wiz-validators';

/**
 * Compares two wiz validation errors and returns true if they are equal
 */
export function wizValidationErrorsEquals(oldv: WizValidationErrors, newv: WizValidationErrors): boolean {
  if (!oldv && !newv) {
    return true;
  } else if (!oldv || !newv) {
    return false;
  } else if (oldv.length !== newv.length) {
    return false;
  } else {
    const result: WizValidationErrors = oldv.filter(pold => {
      const existingValue = newv.find(pnew => {
        return wizValidationErrorEquals(pold, pnew);
      });
      return existingValue !== null && existingValue !== undefined;
  });

    return result && result.length === oldv.length;
  }
}

function wizValidationErrorEquals(pa: WizValidationError, pb: WizValidationError): boolean {
  if (!pa && ! pb) {
    return true;
  } else if (!pa || !pb) {
    return false;
  } else {
    return pa.wizError === pb.wizError && pa.wizErrorParams === pb.wizErrorParams;
  }
}

/**
 * affichage des erreurs dans le container d'erreur du baseComponent cible
 */
export function printErrors (pErrors: WizValidationErrors, pErrorContainer: ViewContainerRef,
  pNumResults: number,
  pClear: boolean): void {
  if (pErrorContainer) {
    // Clear if needed
    if (pClear) {
      pErrorContainer.clear();
    }
    // If there are errors, show the message
    if (pErrors.length ) {

      // Safe calculating number of results to show. This avoid slicing on incorrect indices
      pNumResults = pNumResults > pErrors.length || pNumResults === -1 ? pErrors.length : pNumResults;
      const errorsToShow: WizValidationError[] = pErrors.slice(0, pNumResults);
      // Show them errors
      errorsToShow.forEach((error: WizValidationError) => {
        // Use of component manager to create a WizLabel for each error
        WizComponentManager.instance.addChildTo(
          WizLabel,
          pErrorContainer,
          {
            instanceProperties:
            {
              wizTranslationParams: error.wizErrorParams,
              wizLabel: error.wizError,
              tooltipText: error.wizError,
              wizTextBehavior: 'truncate',
              width: '100%'
            },
            cssClasses: ['error-class', 'error-hint']
          }
        );
      });
    }
  }
}
